import { StatsigConfiguration } from '@eventbrite/statsig';
import { CheckoutState } from '../state';

const getCustomIDs = ({
    event,
    request,
}: {
    event: { id: string; organizer_id: string };
    request: { correlation_id: string; session_id: string };
}) => ({
    correlationId: request?.correlation_id,
    eventId: event?.id,
    organizerId: event?.organizer_id,
    sessionId: request?.session_id,
});

export const getStatsigConfig = (
    state: CheckoutState,
): StatsigConfiguration => ({
    user: {
        appVersion: state.app.appVersion,
        customIDs: getCustomIDs(state.app),
        locale: state.app.locale,
        userID: state.user?.publicId,
        ...(typeof window !== 'undefined'
            ? { userAgent: window.navigator.userAgent }
            : {}),
    },
});
